import { useState } from 'react'

import { useSaveSettings, useSettings } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { fehlertext } from '../../api/client'

/**
 * The installation's default for calculated routes (1.18.0, #84): means of
 * transport and whether tolls are avoided. A trip may override both on its
 * map, in "Punkte verbinden". Saved on change, like the map source -- a
 * switch, not a form.
 *
 * Under "POIs in Routen" next to the stop detection, not under "Ort und
 * Wetter" (1.49.8, from use): both cards say what a point is to a route.
 * That it asks Apple, like the place lookup, is the server's business.
 */
export function RoutenCard() {
  const t = useTexte()
  const settings = useSettings()
  const save = useSaveSettings()
  // The tolerance is typed, not switched (#87): it stays in the field until
  // the field is left, as in `ErkennungCard` -- a number that saves on
  // every keystroke would send "1", "10", "100".
  const [toleranz, setToleranz] = useState<string | null>(null)
  const daten = settings.data
  // Without the ceiling this account is no administration -- the server decided.
  if (!daten?.ceiling || !daten.limits) return null
  const werte = daten.settings
  const grenzen = daten.limits

  const toleranzSichern = () => {
    const wert = Number(toleranz)
    setToleranz(null)
    if (toleranz === null || !Number.isInteger(wert) || wert === werte.route_tolerance_m) return
    save.mutate({ route_tolerance_m: wert })
  }

  return (
    <div className="card card--seite" data-routen-vorgabe="">
      <h2 className="card__titel">{t.routen.titel}</h2>
      <p className="card__lead">{t.routen.lead}</p>
      <label className="field field--luft">
        <span className="field__label">{t.routen.verkehrsmittel}</span>
        <select
          className="field__input"
          name="route_transport"
          value={werte.route_transport}
          disabled={save.isPending}
          onChange={(e) => save.mutate({ route_transport: e.target.value })}
        >
          <option value="Automobile">{t.karte.routen.auto}</option>
          <option value="Cycling">{t.karte.routen.rad}</option>
          <option value="Walking">{t.karte.routen.zuFuss}</option>
        </select>
      </label>
      <label className="routenwahl__maut">
        <input
          type="checkbox"
          name="route_avoid_tolls"
          checked={werte.route_avoid_tolls === '1'}
          disabled={save.isPending}
          onChange={(e) => save.mutate({ route_avoid_tolls: e.target.checked ? '1' : '0' })}
        />
        <span>{t.karte.routen.mautVermeiden}</span>
      </label>
      <p className="leise">{t.karte.routen.nichtAbwaehlbar}</p>
      <label className="field field--luft">
        <span className="field__label">{t.routen.toleranz}</span>
        <input
          className="field__input"
          type="number"
          inputMode="numeric"
          name="route_tolerance_m"
          value={toleranz ?? String(werte.route_tolerance_m)}
          min={grenzen.route_tolerance_m.min}
          max={grenzen.route_tolerance_m.max}
          onChange={(e) => setToleranz(e.target.value)}
          onBlur={toleranzSichern}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              e.currentTarget.blur()
            }
          }}
        />
        <span className="feld__hinweis">{t.routen.toleranzHinweis}</span>
      </label>
      {save.isError && (
        <p className="notice" role="alert">{fehlertext(save.error)}</p>
      )}
    </div>
  )
}
